import { PetParentReportsSection, AdoptionReportsSection } from './components/ReportsSection';
import { PetszelReportsSection } from './components/PetszelReportsSection';
import { OrderSection } from './components/OrderSection';
import { CanadianOrderSection } from './components/CanadianOrderSection';
import { CmsResourcesSection } from './components/CmsResourcesSection';
import { useEffect } from 'react';
import { TranslationKeyEnum } from '../../types/constants';
import { useTranslation } from '../../hooks/useTranslation';
import PetszelReportingBanner from '../../components/PetszelReporting/PetszelReportingBanner';
import { useShelterState } from '../../hooks/useShelter';
import { usePopupManager } from '../../context/PopupManagerContext';
import CmsAnnouncementBanner from '../../components/CmsAnnouncementBanner';
import { useFeatureFlags } from '../../hooks/useFeatureFlags';
import { useContentstackPage } from '../../hooks/useContentstack';

export const Home = () => {
  const { t } = useTranslation();
  const { shelter } = useShelterState();
  const { enableOrders, enablePetszelPromotion } = useFeatureFlags();
  const { updatePopupState } = usePopupManager();
  const { data: canadianOrderPageData } = useContentstackPage('ca-order-section');

  useEffect(() => {
    // set page title
    document.title = t(TranslationKeyEnum.Home);
  }, [t]);

  // Update popup state with shelter data
  useEffect(() => {
    if (shelter) {
      updatePopupState({
        shelter: {
          is_petszel_enabled: shelter.is_petszel_enabled,
        },
      });
    }
  }, [shelter, updatePopupState]);

  return (
    <div className="flex flex-col gap-24 mx-auto w-full">
      <CmsAnnouncementBanner />
      {enableOrders && <OrderSection />}
      {canadianOrderPageData && <CanadianOrderSection />}
      {shelter?.is_petszel_enabled ? (
        <PetszelReportsSection />
      ) : (
        <>
          {shelter && enablePetszelPromotion && <PetszelReportingBanner />}
          <PetParentReportsSection />
          <AdoptionReportsSection />
        </>
      )}
      <CmsResourcesSection />
    </div>
  );
};
